import api from "shared/infra/services/api";

import IOffer from "@CheckoutStepsOffers/@types/offer";

export const getAllAddress = async () => {
  try {
    const response = await api.get("address?orderBy=id&orderBy=desc");

    const addressList = response?.data?.data;

    return addressList;
  } catch (error) {
    throw new Error(
      "[Payment :: getAllAddress] - Failed to get all address",
      error,
    );
  }
};

export const getUserSettings = async () => {
  try {
    const response = await api.get("user/setting");
    return response.data.attrs;
  } catch (error) {
    throw new Error(
      "[Payment :: getUserSettings] - Failed to get user settings",
      error,
    );
  }
};

export const getAllCreditCards = async () => {
  try {
    const response = await api.get("pay/card");
    return response.data.attrs;
  } catch (error) {
    throw new Error(
      "[Payment :: getAllCreditCards] - Failed to get all credit cards",
      error,
    );
  }
};

export const getProductData = async (
  uuid: string,
  headers: any,
): Promise<IOffer> => {
  if (!uuid) return null;

  try {
    const response = await api.get(`offer/direct/${uuid}`, { headers });

    const productData = response?.data?.data;

    return productData;
  } catch (error: any) {
    console.log("error →", error);

    return null;
  }
};
